import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const AutoCompleteSuggestions = ({
  suggestions,
  label,
  searchUrl,
  hasQuickSearch,
  selectedIndex,
  isVisible,
  id,
}) => {
  if (!Array.isArray(suggestions) || suggestions.length === 0) return null;

  const ulProps = hasQuickSearch
    ? { className: 'c-search__quicksearch__autocomplete' }
    : {
        role: 'listbox',
        'aria-expanded': isVisible,
        id: `${id}_listbox`,
        className: 'c-search__autocomplete',
      };

  return (
    <ul {...ulProps}>
      {label && (
        <span className="c-search__quicksearch__autocomplete__label">
          {label}
        </span>
      )}
      {suggestions.map((term, index) => {
        const itemClass = classNames({
          'c-search__autocomplete__item': !hasQuickSearch,
          'c-search__autocomplete__item--is-selected':
            !hasQuickSearch && selectedIndex === index,
          'c-search__quicksearch__autocomplete__item': hasQuickSearch,
          'c-search__quicksearch__autocomplete__item--is-selected':
            hasQuickSearch && selectedIndex === index,
        });
        return (
          <li role="option" className={itemClass} key={index}>
            <a href={encodeURI(`${searchUrl}?q=${term}`)}>{term}</a>
          </li>
        );
      })}
    </ul>
  );
};

AutoCompleteSuggestions.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string,
  searchUrl: PropTypes.string,
  hasQuickSearch: PropTypes.bool,
  selectedIndex: PropTypes.number,
  id: PropTypes.string,
  isVisible: PropTypes.bool,
};

export default AutoCompleteSuggestions;
